import React from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';
import LoadMore from './LoadMore';


const Err = () => {
    const {showDummyImage} = useAuth()
    return (
        <section className="error">
        <div className="container">
          <div className="error-wrapper">
            <div className="error-img">
              <img src={require("../../assets/images/common/error.png")} alt={'error'} onError={({currentTarget},imageSize='335X335')=>showDummyImage({currentTarget},imageSize)}/>
            </div>
            <div className="error-content">
              <h3>404</h3>
              <p>Page not found!</p>
              <small>
                The page you are looking for does not exist or has been moved!
              </small>
            </div>
            <Link to="/">
                 <LoadMore btnTitle= "Back to Marketplace"/>
            </Link>
          </div>
        </div>
      </section>
    );
};

export default Err;